import { DataGetAdapter } from '../../adapter';

export default async function DataGetUseCase(event) {

    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('bmsf.dev.bpimsapps.com');
    const isUAT = url.includes('bmsf.uat.bpimsapps.com');
    const isProd = url.includes('projectbringme.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
    ? 'https://partners-api.dev.bpimsapps.com/data/get'
    : isUAT
    ? 'https://partners-api.uat.bpimsapps.com/data/get'
    : isProd
    ? 'https://partners-api.bpimsapps.com/data/get'
    : 'https://partners-api.bpimsapps.com/data/get'; // fallback for non-prod environments


    // const requestUrl = 'https://partners-api.dev.bpimsapps.com/data/get';

    const payload = {
        data: {
          ...event,
         }
    };

    const result = await DataGetAdapter(endpoint, JSON.stringify(payload));
    return result;
}
